<template>
  <div class="mobile-menu__list">
    <template v-for="item in menuState">
      <div v-if="item.divider" class="inner-menu__content-item-divider" :key="item.key"></div>
      <!--      <geo-header v-else-if="item.geoHeader" :key="item.key" :enable-popup="false"></geo-header>-->
      <div v-else class="inner-menu__content-item" :class="{ 'inner-menu__content-item--accent': item.accent }"  :key="item.full_url">
        <a :href="item.full_url" @click="item.action ? item.action($event, item) : null">
          <img :src="item.icon" alt="">
          <div>{{ item.name }}</div>
          <div v-if="item.additionalInfo" class="inner-menu__content-item-info">{{ item.additionalInfo }}</div>
        </a>
        <button v-if="(item.items && item.items.length > 0) || item.count" class="inner-menu__content-item-trigger" @click="item.action ? item.action($event, item) : null">
          <div v-if="item.count && parseInt(item.count) > 0" class="inner-menu__content-item-count">
            {{ item.count }}
          </div>
          <svg v-else width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.19114 2.02793L5.85938 3.35688L13.8462 11.3456L15.177 10.0138L7.19114 2.02699V2.02793Z" fill="#CCCCCC"/>
            <path d="M5.8584 16.6692L7.1911 18L15.176 10.0141L13.8452 8.68235L5.8584 16.6692Z" fill="#CCCCCC"/>
          </svg>
        </button>
      </div>
    </template>
    <inner-level-menu
      :title="innerMenuTitle"
      :content="innerMenuContent"
      :action-btn="innerMenuActionBtn"
      :is-open="innerMenuOpen"
      @hideCurrLevel="hideInnerMenu"
    ></inner-level-menu>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
// import geoHeader from '@/components/user-geo/GeoHeader.vue'
import InnerLevelMenu from '@/components/header/InnerLevelMenu.vue'
import { formattedDeliveryInfo } from '@/mixins'

export default {
  name: 'MobileMenuList',
  data () {
    return {
      innerMenuTitle: {},
      innerMenuContent: [],
      innerMenuOpen: false,
      innerMenuActionBtn: {}
    }
  },
  components: {
    InnerLevelMenu
    // geoHeader
  },
  mixins: [formattedDeliveryInfo],
  methods: {
    ...mapActions(['REMOVE_CATEGORY_FROM_COMPARISON']),
    hideInnerMenu () {
      this.innerMenuActionBtn = {}
      this.innerMenuOpen = false
    },
    openBuyersMenu (e, item) {
      e.preventDefault()
      this.innerMenuTitle = {
        text: this.$t('up.menu.buyers'),
        icon: '/img/svgo/header/buyers.svg'
      }
      this.innerMenuContent = item.items
      this.innerMenuOpen = true
    },
    openComparisonMenu (e, item) {
      e.preventDefault()
      this.innerMenuTitle = {
        text: this.$t('up.menu.comparison'),
        icon: '/img/svgo/header/compare.svg'
      }
      if (this.comparisonItems.length) {
        this.innerMenuContent = this.comparisonItems
        this.innerMenuActionBtn = {
          action: this.handleComparisonClick,
          title: this.$t('to_compare_btn')
        }
      } else {
        this.innerMenuContent = [
          {
            name: this.$t('up.menu.disable-comparison-text'),
            full_url: '#',
            action: (e) => { e.preventDefault() },
            disablePointerEvents: true
          }
        ]
        this.innerMenuActionBtn = {
          action: this.handleToCatalogClick,
          title: this.$t('to_catalog_btn'),
          type: 'plain'
        }
      }
      this.innerMenuOpen = true
    },
    handleToCatalogClick () {
      location.href = this.urlLanguagePrefix + '/catalog'
    },
    handleComparisonClick () {
      const categories = this.comparisonInfoHeader.data
      const firstCategoryId = Object.keys(categories)[0]
      if (firstCategoryId) {
        window.location.href = categories[firstCategoryId].compare_url
      }
    },
    removeAction (url) {
      this.REMOVE_CATEGORY_FROM_COMPARISON(url).then(() => {
        this.innerMenuContent = this.comparisonItems
      })
    },
    openDeliveryLocationPopup () {
      this.$modal.show('city-location-modal')
    },
    openDeliveryStorePopup () {
      this.$modal.show('map-modal', {
        spots: this.formatDeliverySpotsInfo(this.storesInCity.map(el => {
          return {
            ...el,
            quantity: 20
          }
        }), 'chooseStore'),
        mailName: 'chooseStore',
        withoutAddToCart: true,
        title: this.$t('reserve_map_title')
      })
    }
  },
  computed: {
    ...mapState({
      comparisonInfoHeader: state => state.productComparison.comparisonInfoHeader,
      userCity: state => state.geoLocation.userCity,
      userStore: state => state.geoLocation.userStore,
      storesInCity: state => state.geoLocation.storesInCity
    }),
    ...mapGetters(['urlLanguagePrefix', 'isUkLanguage', 'productsToComparison']),
    ...mapGetters('wishlist', ['wishlistQuantity']),
    userCityName () {
      return this.userCity?.name || this.$t('delivery-store-balance.not-choose')
    },
    userStoreName () {
      return this.userStore?.name || this.$t('delivery-store-balance.not-choose')
    },
    comparisonItems () {
      if (this.comparisonInfoHeader && this.comparisonInfoHeader.data && Object.values(this.comparisonInfoHeader.data).length) {
        const dataArray = Object.values(this.comparisonInfoHeader.data)
        return dataArray.map(el => {
          return {
            name: el.name + ' (' + Object.keys(el.product_list).length + ')',
            full_url: el.compare_url,
            removeUrl: el.remove_cat_url,
            removeAction: this.removeAction
          }
        })
      }
      return []
    },
    menuState () {
      return [
        {
          name: this.$t('up.menu.shares'),
          full_url: this.urlLanguagePrefix + '/sale/',
          icon: '/img/svgo/header/discount.svg'
        },
        {
          name: this.$t('up.menu.outlet'),
          full_url: this.urlLanguagePrefix + '/outlet/',
          icon: '/img/svgo/header/outlet.svg'
        },
        {
          name: this.$t('up.menu.black-week'),
          full_url: this.urlLanguagePrefix + '/black-friday/',
          icon: '/img/svgo/header/black-friday.svg',
          accent: true
        },
        {
          name: this.$t('up.menu.novelty'),
          full_url: this.urlLanguagePrefix + '/novynky/',
          icon: '/img/svgo/header/sale-tag.svg'
        },
        {
          name: this.$t('up.menu.stores'),
          full_url: this.urlLanguagePrefix + '/shops/',
          icon: '/img/svgo/header/shop-mobile.svg'
        },
        // {
        //   name: this.$t('up.menu.garden'),
        //   full_url: this.urlLanguagePrefix + '/vse-dlia-sadu/',
        //   icon: '/img/svgo/header/leaf.svg'
        // },
        // {
        //   name: this.$t('up.menu.outlet'),
        //   full_url: this.urlLanguagePrefix + '/outlet/',
        //   icon: '/img/svgo/header/outlet.svg'
        // },
        // {
        //   name: this.$t('up.menu.mastery.club'),
        //   full_url: this.urlLanguagePrefix + '/news/klub-majsternosti-dnipro-m/',
        //   icon: '/img/svgo/header/club.svg'
        // },
        // {
        //   key: 'geoheader_start',
        //   divider: true
        // },
        // {
        //   key: 'geoheader_component',
        //   geoHeader: true
        // },
        {
          key: 'location_start',
          divider: true
        },
        {
          name: this.$t('delivery-store-balance.city'),
          icon: '/img/svgo/header/location.svg',
          additionalInfo: this.userCityName,
          action: this.openDeliveryLocationPopup
        },
        ...(this.storesInCity && this.storesInCity.length > 0 ? [{
          name: this.$t('delivery-store-balance.store'),
          icon: '/img/svgo/header/store.svg',
          additionalInfo: this.userStoreName,
          action: this.openDeliveryStorePopup
        }] : []),
        {
          key: 'comparison_start',
          divider: true
        },
        {
          name: this.$t('up.menu.wishlist'),
          full_url: this.urlLanguagePrefix + '/cabinet/wishlist/',
          icon: '/img/svgo/header/heart.svg',
          count: this.wishlistQuantity
        },
        {
          name: this.$t('up.menu.comparison'),
          icon: '/img/svgo/header/compare.svg',
          count: this.productsToComparison.length,
          action: this.openComparisonMenu
        },
        {
          key: 'comparison_end',
          divider: true
        },
        {
          name: this.$t('up.menu.buyers'),
          full_url: '',
          icon: '/img/svgo/header/buyers.svg',
          action: this.openBuyersMenu,
          items: [
            {
              name: this.$t('up.menu.shipping.and.pay'),
              full_url: this.urlLanguagePrefix + '/dostavka-i-oplata/',
              icon: '/img/svgo/header/delivery.svg'
            },
            {
              name: this.$t('down.menu.product_return'),
              full_url: this.urlLanguagePrefix + '/dostavka-i-oplata/#return-goods',
              icon: '/img/svgo/header/return.svg'
            },
            {
              name: this.$t('support.drop.list.warranty'),
              full_url: this.urlLanguagePrefix + '/garantia-i-servisu/',
              icon: '/img/svgo/header/service.svg'
            },
            // {
            //   name: this.$t('down.menu.loyalty.program'),
            //   full_url: this.urlLanguagePrefix + '/loyalty-program/',
            //   icon: '/img/svgo/header/loyalty.svg'
            // },
            {
              name: this.$t('up.menu.comments'),
              full_url: this.urlLanguagePrefix + '/comments/',
              icon: '/img/svgo/header/comments.svg'
            },
            {
              name: this.$t('up.menu.distribution'),
              full_url: this.urlLanguagePrefix + '/dystrybucja/',
              icon: '/img/svgo/header/store.svg'
            },
            {
              name: this.$t('up.menu.blog'),
              full_url: this.urlLanguagePrefix + '/blog/',
              icon: '/img/svgo/header/blog.svg'
            },
            {
              name: this.$t('down.menu.faq'),
              full_url: this.urlLanguagePrefix + '/faq/',
              icon: '/img/svgo/header/faq.svg'
            },
            {
              name: this.$t('up.menu.news'),
              full_url: this.urlLanguagePrefix + '/news/',
              icon: '/img/svgo/header/blog.svg'
            }
            // {
            //   name: this.$t('up.menu.business-clients'),
            //   full_url: this.urlLanguagePrefix + '/biznes-kliyentam/',
            //   icon: '/img/svgo/header/business-clients.svg'
            // }
          ]
        },
        {
          name: this.$t('down.menu.regulations'),
          full_url: this.urlLanguagePrefix + '/regulamin-sklepu-internetowego/',
          icon: '/img/svgo/header/regulations.svg'
        },
        {
          name: this.$t('down.menu.policy'),
          full_url: this.urlLanguagePrefix + '/terms-and-conditions/',
          icon: '/img/svgo/header/policy.svg'
        },
        {
          name: this.$t('down.menu.cookies'),
          full_url: this.urlLanguagePrefix + '/cookies-policy/',
          icon: '/img/svgo/header/info.svg'
        }
        // {
        //   name: this.$t('up.menu.job'),
        //   full_url: this.urlLanguagePrefix + '/career/',
        //   icon: '/img/svgo/header/dm-job.svg'
        // }
      ]
    }
  }
}
</script>
<style lang="sass">
.mobile-menu__list
  .geo-header
    padding: 12px 15px
    min-height: 44px
.inner-menu__content-item
  &-info
    color: #909090
    font-size: 14px
    margin-left: auto
    margin-right: -15px
    padding-left: 10px
    text-align: right
  &-divider
    min-height: 1px
    height: 1px
    background-color: #E7E7E7
    margin: 5px 0
</style>
<style lang="sass" scoped>
.mobile-menu__list
  display: flex
  flex-grow: 1
  flex-direction: column
  overflow-y: auto
.inner-menu__content-item
  padding: 12px 15px
  min-height: 44px
  font-size: 14px
  font-weight: 400
  transition: color 0.2s
  &--accent a
    color: #ff2f00
  &:hover
    color: #ff2f00
  &-count
    width: 24px
    height: 24px
    border-radius: 50%
    background-color: #FF2F00
    color: #fff
    display: flex
    justify-content: center
    flex-shrink: 0
    font-size: 14px
    font-weight: 500
    margin-left: auto
    line-height: 23px
  a
    margin-right: 15px
</style>
